export default "__VITE_ASSET__bJM_TmkO__"